module.exports = __webpack_public_path__ + "a2ba5fa06785bb58d23491592b3835c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201509_Presse_AVANGA_RN_2_1MB.jpg
// module id = 560
// module chunks = 0